// // frontend/src/pages/Test.jsx
// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import "./test.css";

// const API_BASE =
//   (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/$/, "");

// export default function Test() {
//   const navigate = useNavigate();

//   const TEST_ID = 1;
//   const DURATION_SECONDS = 60 * 60;

//   const [questions, setQuestions] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [answers, setAnswers] = useState({});
//   const [marked, setMarked] = useState({});
//   const [started, setStarted] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [attemptId, setAttemptId] = useState(null);
//   const [timeLeft, setTimeLeft] = useState(DURATION_SECONDS);
//   const [submitting, setSubmitting] = useState(false);

//   const [submittedSuccess, setSubmittedSuccess] = useState(false);
//   const [submittedMessage, setSubmittedMessage] = useState("");

//   const timerRef = useRef(null);
//   const submittedRef = useRef(false);

//   /* ---------------- LOGIN PROTECTION ---------------- */

//   useEffect(() => {
//     const token = localStorage.getItem("candidateToken");
//     if (!token) navigate("/candidate");
//   }, [navigate]);

//   /* ---------------- ANTI-CHEATING ---------------- */

//   useEffect(() => {
//     if (!started) return;

//     const handleViolation = (reason) => {
//       if (!submittedRef.current) {
//         alert(`❌ ${reason} detected. Test auto submitted.`);
//         submitTest(true, reason);
//       }
//     };

//     const handleVisibility = () => {
//       if (document.hidden) handleViolation("Tab Switch");
//     };

//     const handleFullscreen = () => {
//       if (!document.fullscreenElement) {
//         handleViolation("Fullscreen Exit");
//       }
//     };

//     document.addEventListener("visibilitychange", handleVisibility);
//     document.addEventListener("fullscreenchange", handleFullscreen);

//     return () => {
//       document.removeEventListener("visibilitychange", handleVisibility);
//       document.removeEventListener("fullscreenchange", handleFullscreen);
//     };
//   }, [started]);

//   /* ---------------- CLEANUP ---------------- */

//   useEffect(() => {
//     return () => {
//       if (timerRef.current) clearInterval(timerRef.current);
//     };
//   }, []);

//   function prettyTime(sec) {
//     const m = Math.floor(sec / 60).toString().padStart(2, "0");
//     const s = (sec % 60).toString().padStart(2, "0");
//     return `${m}:${s}`;
//   }

//   /* ---------------- LOAD QUESTIONS ---------------- */

//   async function loadQuestions() {
//     setLoading(true);
//     try {
//       const token = localStorage.getItem("candidateToken");

//       const url = token
//         ? `${API_BASE}/api/tests/${TEST_ID}/questions/me`
//         : `${API_BASE}/api/tests/${TEST_ID}/questions`;

//       const headers = token ? { Authorization: `Bearer ${token}` } : {};

//       const res = await axios.get(url, { headers });

//       const normalized = (res.data?.questions || []).map((q, idx) => ({
//         id: q.id ?? idx + 1,
//         text: q.text ?? "",
//         choices: q.choices || {},
//       }));

//       setQuestions(normalized);
//       return normalized;
//     } catch (err) {
//       console.error(err);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   }

//   /* ---------------- START TEST ---------------- */

//   async function handleStart() {
//     try {
//       const qs = await loadQuestions();
//       if (!qs.length) return alert("No questions available");

//       const token = localStorage.getItem("candidateToken");

//       if (token) {
//         const res = await axios.post(
//           `${API_BASE}/api/test/${TEST_ID}/start`,
//           {},
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         setAttemptId(res.data.attemptId);
//       }

//       const el = document.documentElement;
//       if (el.requestFullscreen) {
//         await el.requestFullscreen();
//       }

//       setStarted(true);
//       setTimeLeft(DURATION_SECONDS);

//       timerRef.current = setInterval(() => {
//         setTimeLeft((t) => {
//           if (t <= 1) {
//             clearInterval(timerRef.current);

//             if (!submittedRef.current) {
//               submitTest(true, "Time Over");
//             }

//             return 0;
//           }
//           return t - 1;
//         });
//       }, 1000);

//     } catch (err) {
//       console.error(err);
//       alert("Failed to start test");
//     }
//   }

//   /* ---------------- ANSWERS ---------------- */

//   function handleSelect(choice) {
//     const q = questions[currentIndex];
//     if (!q) return;

//     setAnswers({ ...answers, [q.id]: choice });
//   }

//   function toggleMark() {
//     const q = questions[currentIndex];
//     if (!q) return;

//     const copy = { ...marked };
//     copy[q.id] ? delete copy[q.id] : (copy[q.id] = true);
//     setMarked(copy);
//   }

//   function handleSaveAndNext() {
//     setCurrentIndex((i) => Math.min(i + 1, questions.length - 1));
//   }

//   /* ---------------- SUBMIT ---------------- */

//   async function submitTest(isAuto = false, reason = "Manual Submit") {
//     if (!attemptId) {
//       alert("❌ Test not started properly");
//       return;
//     }

//     if (submittedRef.current) return;

//     if (!isAuto && !window.confirm("Submit test?")) return;

//     submittedRef.current = true;
//     setSubmitting(true);

//     try {
//       const token = localStorage.getItem("candidateToken");

//       await axios.post(
//         `${API_BASE}/api/test/${TEST_ID}/submit`,
//         {
//           attemptId,
//           answers,
//           reason,
//         },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       setSubmittedSuccess(true);
//       setSubmittedMessage(`✅ Test submitted (${reason})`);

//       clearInterval(timerRef.current);

//       // ✅ ONLY FIX APPLIED HERE (NO OTHER CHANGE)
//       try {
//         if (document.fullscreenElement) {
//           document.exitFullscreen();
//         }
//       } catch (e) {
//         console.warn("Fullscreen exit skipped");
//       }

//       setTimeout(() => {
//         navigate("/candidate/dashboard");
//       }, 1500);

//     } catch (err) {
//       console.error(err);
//       alert("❌ Submission failed");
//       submittedRef.current = false;
//     } finally {
//       setSubmitting(false);
//     }
//   }

//   /* ---------------- START SCREEN ---------------- */

//   if (!started) {
//     return (
//       <div className="container mt-5">
//         <h2>Eligibility Test</h2>

//         <div className="alert alert-warning">
//           <ul>
//             <li>Total Questions: <b>50</b></li>
//             <li>Duration: <b>60 Minutes</b></li>
//             <li>Attempts Allowed: <b>3</b></li>
//             <li>Auto submit after time ends</li>
//             <li>❌ Tab switch = cheating (auto submit)</li>
//           </ul>
//         </div>

//         <button className="btn btn-primary" onClick={handleStart}>
//           Start Test
//         </button>
//       </div>
//     );
//   }

//   const q = questions[currentIndex];
//   if (!q) return <div>Loading...</div>;

//   const keys = Object.keys(q.choices || {}).filter((k) => q.choices[k]);

//   return (
//     <div className="exam-overlay">
//       <div className="exam-root">

//         <div className="exam-header">
//           <h1>Concerted Path Test</h1>
//           <div className="timer-box">{prettyTime(timeLeft)}</div>
//         </div>

//         <div className="exam-body">

//           <div className="question-area">
//             <div className="question-card">

//               <h4>Question {currentIndex + 1}</h4>

//               <div
//                 className="question-text"
//                 dangerouslySetInnerHTML={{ __html: q.text }}
//               />

//               <div className="choices">
//                 {keys.map((k) => (
//                   <label key={k} className="choice">
//                     <input
//                       type="radio"
//                       checked={answers[q.id] === k}
//                       onChange={() => handleSelect(k)}
//                     />
//                     <b>{k}.</b> {q.choices[k]}
//                   </label>
//                 ))}
//               </div>

//               <div className="action-bar">
//                 <button onClick={() => setCurrentIndex(i => Math.max(i - 1, 0))}>
//                   Previous
//                 </button>

//                 <button onClick={handleSaveAndNext}>
//                   Save & Next
//                 </button>

//                 <button onClick={toggleMark}>
//                   {marked[q.id] ? "Unmark" : "Mark"}
//                 </button>

//                 <button
//                   onClick={() =>
//                     setCurrentIndex(i => Math.min(i + 1, questions.length - 1))
//                   }
//                 >
//                   Next
//                 </button>

//                 <button
//                   className="btn-submit"
//                   disabled={submitting}
//                   onClick={() => submitTest(false, "Manual Submit")}
//                 >
//                   {submitting ? "Submitting..." : "Submit"}
//                 </button>
//               </div>

//             </div>
//           </div>

//           <div className="palette-area">
//             <div className="palette-grid">
//               {questions.map((_, i) => {
//                 const id = questions[i].id;

//                 let cls = "pbtn";
//                 if (answers[id]) cls += " answered";
//                 if (marked[id]) cls += " marked";
//                 if (i === currentIndex) cls += " current";

//                 return (
//                   <button
//                     key={i}
//                     className={cls}
//                     onClick={() => setCurrentIndex(i)}
//                   >
//                     {i + 1}
//                   </button>
//                 );
//               })}
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// }



// frontend/src/pages/Test.jsx
import React, { useEffect, useState, useRef } from "react";
import api from "../utils/api"; // ✅ CHANGED
import { useNavigate } from "react-router-dom";
import "./test.css";

export default function Test() {
  const navigate = useNavigate();

  const TEST_ID = 1;
  const DURATION_SECONDS = 60 * 60;

  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [marked, setMarked] = useState({});
  const [started, setStarted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attemptId, setAttemptId] = useState(null);
  const [timeLeft, setTimeLeft] = useState(DURATION_SECONDS);
  const [submitting, setSubmitting] = useState(false);

  const [submittedSuccess, setSubmittedSuccess] = useState(false);
  const [submittedMessage, setSubmittedMessage] = useState("");

  const timerRef = useRef(null);
  const submittedRef = useRef(false);

  /* ---------------- LOGIN PROTECTION ---------------- */

  useEffect(() => {
    const token = localStorage.getItem("candidateToken");
    if (!token) navigate("/candidate");
  }, [navigate]);

  /* ---------------- ANTI-CHEATING ---------------- */

  useEffect(() => {
    if (!started) return;

    const handleViolation = (reason) => {
      if (!submittedRef.current) {
        alert(`❌ ${reason} detected. Test auto submitted.`);
        submitTest(true, reason);
      }
    };

    const handleVisibility = () => {
      if (document.hidden) handleViolation("Tab Switch");
    };

    const handleFullscreen = () => {
      if (!document.fullscreenElement) {
        handleViolation("Fullscreen Exit");
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);
    document.addEventListener("fullscreenchange", handleFullscreen);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
      document.removeEventListener("fullscreenchange", handleFullscreen);
    };
  }, [started]);

  /* ---------------- CLEANUP ---------------- */

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  function prettyTime(sec) {
    const m = Math.floor(sec / 60).toString().padStart(2, "0");
    const s = (sec % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  }

  /* ---------------- LOAD QUESTIONS ---------------- */

  async function loadQuestions() {
    setLoading(true);
    try {
      const token = localStorage.getItem("candidateToken");

      const url = token
        ? `/api/tests/${TEST_ID}/questions/me`
        : `/api/tests/${TEST_ID}/questions`;

      const res = await api.get(url); // ✅ CHANGED

      const normalized = (res.data?.questions || []).map((q, idx) => ({
        id: q.id ?? idx + 1,
        text: q.text ?? "",
        choices: q.choices || {},
      }));

      setQuestions(normalized);
      return normalized;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  /* ---------------- START TEST ---------------- */

  async function handleStart() {
    try {
      const qs = await loadQuestions();
      if (!qs.length) return alert("No questions available");

      const token = localStorage.getItem("candidateToken");

      if (token) {
        const res = await api.post(`/api/test/${TEST_ID}/start`, {}); // ✅ CHANGED
        setAttemptId(res.data.attemptId);
      }

      const el = document.documentElement;
      if (el.requestFullscreen) {
        await el.requestFullscreen();
      }

      setStarted(true);
      setTimeLeft(DURATION_SECONDS);

      timerRef.current = setInterval(() => {
        setTimeLeft((t) => {
          if (t <= 1) {
            clearInterval(timerRef.current);

            if (!submittedRef.current) {
              submitTest(true, "Time Over");
            }

            return 0;
          }
          return t - 1;
        });
      }, 1000);

    } catch (err) {
      console.error(err);
      alert("Failed to start test");
    }
  }

  /* ---------------- ANSWERS ---------------- */

  function handleSelect(choice) {
    const q = questions[currentIndex];
    if (!q) return;

    setAnswers({ ...answers, [q.id]: choice });
  }

  function toggleMark() {
    const q = questions[currentIndex];
    if (!q) return;

    const copy = { ...marked };
    copy[q.id] ? delete copy[q.id] : (copy[q.id] = true);
    setMarked(copy);
  }

  function handleSaveAndNext() {
    setCurrentIndex((i) => Math.min(i + 1, questions.length - 1));
  }

  /* ---------------- SUBMIT ---------------- */

  async function submitTest(isAuto = false, reason = "Manual Submit") {
    if (!attemptId) {
      alert("❌ Test not started properly");
      return;
    }

    if (submittedRef.current) return;

    if (!isAuto && !window.confirm("Submit test?")) return;

    submittedRef.current = true;
    setSubmitting(true);

    try {
      await api.post(`/api/test/${TEST_ID}/submit`, { // ✅ CHANGED
        attemptId,
        answers,
        reason,
      });

      setSubmittedSuccess(true);
      setSubmittedMessage(`✅ Test submitted (${reason})`);

      clearInterval(timerRef.current);

      try {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
      } catch (e) {
        console.warn("Fullscreen exit skipped");
      }

      setTimeout(() => {
        navigate("/candidate/dashboard");
      }, 1500);

    } catch (err) {
      console.error(err);
      alert("❌ Submission failed");
      submittedRef.current = false;
    } finally {
      setSubmitting(false);
    }
  }

  /* ---------------- START SCREEN ---------------- */

  if (!started) {
    return (
      <div className="container mt-5">
        <h2>Eligibility Test</h2>

        <div className="alert alert-warning">
          <ul>
            <li>Total Questions: <b>50</b></li>
            <li>Duration: <b>60 Minutes</b></li>
            <li>Attempts Allowed: <b>3</b></li>
            <li>Auto submit after time ends</li>
            <li>❌ Tab switch = cheating (auto submit)</li>
          </ul>
        </div>

        <button className="btn btn-primary" onClick={handleStart}>
          Start Test
        </button>
      </div>
    );
  }

  const q = questions[currentIndex];
  if (!q) return <div>Loading...</div>;

  const keys = Object.keys(q.choices || {}).filter((k) => q.choices[k]);

  return (
    <div className="exam-overlay">
      <div className="exam-root">

        <div className="exam-header">
          <h1>Concerted Path Test</h1>
          <div className="timer-box">{prettyTime(timeLeft)}</div>
        </div>

        <div className="exam-body">

          <div className="question-area">
            <div className="question-card">

              <h4>Question {currentIndex + 1}</h4>

              <div
                className="question-text"
                dangerouslySetInnerHTML={{ __html: q.text }}
              />

              <div className="choices">
                {keys.map((k) => (
                  <label key={k} className="choice">
                    <input
                      type="radio"
                      checked={answers[q.id] === k}
                      onChange={() => handleSelect(k)}
                    />
                    <b>{k}.</b> {q.choices[k]}
                  </label>
                ))}
              </div>

              <div className="action-bar">
                <button onClick={() => setCurrentIndex(i => Math.max(i - 1, 0))}>
                  Previous
                </button>

                <button onClick={handleSaveAndNext}>
                  Save & Next
                </button>

                <button onClick={toggleMark}>
                  {marked[q.id] ? "Unmark" : "Mark"}
                </button>

                <button
                  onClick={() =>
                    setCurrentIndex(i => Math.min(i + 1, questions.length - 1))
                  }
                >
                  Next
                </button>

                <button
                  className="btn-submit"
                  disabled={submitting}
                  onClick={() => submitTest(false, "Manual Submit")}
                >
                  {submitting ? "Submitting..." : "Submit"}
                </button>
              </div>

            </div>
          </div>

          <div className="palette-area">
            <div className="palette-grid">
              {questions.map((_, i) => {
                const id = questions[i].id;

                let cls = "pbtn";
                if (answers[id]) cls += " answered";
                if (marked[id]) cls += " marked";
                if (i === currentIndex) cls += " current";

                return (
                  <button
                    key={i}
                    className={cls}
                    onClick={() => setCurrentIndex(i)}
                  >
                    {i + 1}
                  </button>
                );
              })}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}